import { Icons } from '@/utils';
import { NIcon } from 'naive-ui';
import { defineComponent, withKeys } from 'vue';
import './AppHeaderSearchBar.scss';

export const AppHeaderSearchBar = defineComponent({
	name: 'AppHeaderSearchBar',

	emits: {
		search: (query: string) => true,
	},

	data: () => ({
		searchQuery: '',
		showModal: false,
	}),

	methods: {
		handleSearch() {
			this.$emit('search', this.searchQuery);
			this.searchQuery = '';
			this.showModal = false;
		},
		closeModal() {
			this.searchQuery = '';
			this.showModal = false;
		},
	},

	render() {
		return (
			<>
				<div class="clickable" onClick={() => (this.showModal = true)}>
					<NIcon component={Icons.Search} size="24" />
				</div>

				{this.showModal && (
					<div class="search-modal" onClick={this.closeModal}>
						<div class="modal-content" onClick={(e) => e.stopPropagation()}>
							<div class="search-input-container">
								<input
									class="search-input"
									autofocus
									minlength={3}
									type="text"
									placeholder="Digite sua pesquisa"
									v-model={this.searchQuery}
									onKeydown={withKeys(() => this.handleSearch(), ['enter'])}
								/>
								<div class="search-icon">
									<NIcon size="20" component={Icons.Search} />
								</div>
								<div class="search-tip">Pressione Enter para iniciar a busca</div>
							</div>
						</div>
					</div>
				)}
			</>
		);
	},
});
